import axios from "axios";
import { idText } from "typescript";
import { getToken, getUser } from "../Utils/Common";
import { getAPICall, postAPICall, postAPICall2, putAPICall, deleteAPICall, getWithParamsAPICall } from "./axiosMethodCalls";


export const getAllCategories = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "categories/getAll"
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAllModifier = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "menus/getAll", {is_modifier: 1}
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const searchCategories = async (name) => {
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "categories/search", {
                term: name
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const createCategories = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "categories/create", {
                requester: getUser(),
                token: getToken(),
                name: data.name,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateCategories = async (data) => {
    try {
        const params = new URLSearchParams();
        params.append('name',data.name)
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "categories/update/" + data.id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


//GET
export const deleteCategories = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "categories/delete/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};